export const byCompanyPortfolioChart = {
    title: '技術ポートフォリオ　企業別比較',
    description:
        '選択企業が保有する特許出願が含まれる技術群（クラスタ）を表示しています。\nクラスタの配置はクラスタ&バリューチェーンと同様にテーマ全体の動向を表す一方、バブルの大きさが各企業固有の数値（スコアなど）を表します。',
    copy: 'コピー',
    download: 'ダウンロード',
    setting: '設定',
    labelFixedMsg: 'クラスタを選択するにはラベル固定をオフにしてください',

    // csvのヘッダー
    column1: 'クラスタID',
    column2: 'クラスタ名',
    column3: '領域',
    column4: 'スコア（クラスタ）',
    column5: '市場期待値',
    column6: '企業名',
    column7: '登録国',
    column8: 'スコア（企業）',
    column9: '特許出願数',
    column10: '重要特許数',
    column11: '重要特許率',
    column12: '被引用数（平均値）'
}
